<footer class="border-top mt-auto footer">
  <div class="footer-text text-center py-2">
    version {{versionNumber}} <br />
    Copyright reserved SDA informatika Zrt.
  </div>
</footer>
